import React from "react";

/**
 * Compact card that is layout-friendly and small.
 * Inline styles only.
 */
export default function HostRequestCard({ data }) {
  if (!data) return null;

  const created = data.created_at
    ? new Date(data.created_at).toLocaleString()
    : "—";
  const updated = data.updated_at
    ? new Date(data.updated_at).toLocaleString()
    : "—";

  const container = {
    background: "#fff",
    border: "1px solid #E6E9EE",
    borderRadius: 10,
    padding: 12,
    margin: "20px auto",
    boxShadow: "0 6px 18px rgba(15,23,42,0.04)",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: 8,
    minHeight: 120,
  };

  const topRow = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 8,
  };

  const title = {
    fontSize: 14,
    fontWeight: 700,
    color: "#0F172A",
    marginBottom: 2,
  };

  const subtitle = {
    fontSize: 12,
    color: "#475569",
  };

  const infoRow = {
    display: "flex",
    gap: 10,
    alignItems: "center",
    flexWrap: "wrap",
    fontSize: 13,
  };

  const label = { color: "#6B7280", fontSize: 12, marginRight: 6 };
  const value = { color: "#0F172A", fontSize: 13, fontWeight: 600 };

  const smallMeta = { fontSize: 11, color: "#64748B" };

  const badge = {
    padding: "4px 8px",
    borderRadius: 999,
    fontSize: 11,
    fontWeight: 700,
    background: data.is_deleted ? "#FEF2F2" : "#ECFDF5",
    color: data.is_deleted ? "#991B1B" : "#065F46",
    alignSelf: "flex-start",
  };

  const actions = {
    display: "flex",
    gap: 8,
    marginLeft: 8,
  };

  const button = {
    border: "none",
    padding: "6px 10px",
    borderRadius: 8,
    fontSize: 12,
    cursor: "pointer",
  };

  return (
    <article style={container}>
      <div style={topRow}>
        <div>
          <div style={title}>{data.display_name || data.legal_name}</div>
          <div style={subtitle}>
            {data.display_name ? data.legal_name : null}
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div style={badge}>{data.is_deleted ? "Deleted" : "Active"}</div>
        </div>
      </div>

      {/* compact grid of key fields (two columns visually) */}
      <div
        style={{
          display: "flex",
          gap: 18,
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        <div style={{ minWidth: 220 }}>
          <div style={label}>Legal Name</div>
          <div style={value}>{data.legal_name || "—"}</div>
        </div>

        <div style={{ minWidth: 220 }}>
          <div style={label}>Display Name</div>
          <div style={value}>{data.display_name || "—"}</div>
        </div>

        <div style={{ minWidth: 220 }}>
          <div style={label}>Email</div>
          <div style={value}>{data.email || "—"}</div>
        </div>

        <div style={{ minWidth: 160 }}>
          <div style={label}>Phone</div>
          <div style={value}>{data.phone || "—"}</div>
        </div>
      </div>

      {/* description and small meta row */}
      <div
        style={{ borderTop: "1px solid #F3F4F6", paddingTop: 8, marginTop: 6 }}
      >
        <div style={{ fontSize: 12, color: "#6B7280", marginBottom: 6 }}>
          Event
        </div>
        <div
          style={{
            fontSize: 13,
            color: "#0F172A",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {data.event_basics || "—"}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 10,
          }}
        >
          <div style={infoRow}>
            <div>
              <div style={label}>Price</div>
              <div style={value}>
                {data.price ? `₹${Number(data.price).toFixed(2)}` : "—"}
              </div>
            </div>

            <div style={{ marginLeft: 18 }}>
              <div style={label}>Capacity</div>
              <div style={value}>
                {data.capacity ? `${data.capacity}` : "—"}
              </div>
            </div>

            <div
              style={{
                marginLeft: 18,
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <div
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: 999,
                  background: data.terms_accepted ? "#10B981" : "#D1D5DB",
                }}
              />
              <div style={smallMeta}>
                {data.terms_accepted ? "Terms accepted" : "Terms not accepted"}
              </div>
            </div>
          </div>

          <div style={smallMeta}>
            <div>Created: {created}</div>
            <div style={{ marginTop: 4 }}>Updated: {updated}</div>
          </div>
        </div>
      </div>
    </article>
  );
}
